<template>
  <h1>welcome to footer templates pages</h1>
</template>